import { PostgrestResponse } from '@supabase/supabase-js';
import { ICardapioProdutos } from '../../../types/tables/ICardapioProdutos'
import { BaseMultiTenantService } from '../base/BaseMultiTenantService'

/**
 * Serviço para gerenciamento de produtos do cardápio
 * Como cardapio_produtos não tem fk_id_organizacao diretamente,
 * o controle será feito através do relacionamento com cardapio_diario
 */
export class CardapioProdutosService extends BaseMultiTenantService<ICardapioProdutos> {
  constructor() {
    super('cardapio_produtos', [''], 'fk_id_organizacao')
  }

  /**
   * Busca produtos de um cardápio específico
   */
  async getByCardapio(cardapioId: number): Promise<PostgrestResponse<ICardapioProdutos[]>> {
    const { data, error } = await this.client
      .from(this.tableName)
      .select(`
        *,
        produtos:fk_id_produto (
          id,
          descricao,
          descricao_reduzida,
          valor,
          tipo_unidade:fk_id_tipo_unidade (
            descricao
          )
        )
      `)
      .eq('fk_id_cardapio', cardapioId)
      .eq('disponivel', true)
      .is('deleted_at', null)

    if (error) {
      throw new Error(`Erro ao buscar produtos do cardápio: ${error.message}`)
    }

    return { data: data || [], error } as PostgrestResponse<any[]>
  }

  /**
   * Atualiza disponibilidade de um produto no cardápio
   */
  async updateDisponibilidade(id: number, disponivel: boolean): Promise<void> {
    const { error } = await this.client
      .from(this.tableName)
      .update({ disponivel })
      .eq('id', id)

    if (error) {
      throw new Error(`Erro ao atualizar disponibilidade: ${error.message}`)
    }
  }

  /**
   * Atualiza quantidade disponível
   */
  async updateQuantidadeDisponivel(id: number, quantidade: number): Promise<void> {
    const { error } = await this.client
      .from(this.tableName)
      .update({ quantidade_disponivel: quantidade })
      .eq('id', id)

    if (error) {
      throw new Error(`Erro ao atualizar quantidade: ${error.message}`)
    }
  }
}

export const cardapioProdutosService = new CardapioProdutosService()
